import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { Auth } from '@/app/core/services/auth';
import { Permission } from '@/app/core/services/permission';

export const publicGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const permission = inject(Permission);

  if (auth.isAuthenticated()) {
    return permission.getDefaultUrl().pipe(
      map((url) => router.parseUrl(url)),
    );
  }

  return true;
};
